<template>
  <BaseCard
    :heading="location.name"
    gray
    v-test="'fiskaly-location'"
  >
    <Flex direction="column">
      <BaseCheckbox
        v-model="sameAddress"
        :label="$t('integrations.fiskaly_fr.same_address')"
        v-test="'fiskaly-location-same-address'"
      />
      <Address
        v-if="!sameAddress"
        v-model="location.address"
        v-test="'fiskaly-location-address'"
      />
      <BaseInput
        v-model="location.label"
        :label="$t('integrations.fiskaly_fr.siret_number')"
        required
        :maxLength="14"
        :minLength="14"
        :regex="siretRegex"
        type="number"
        :placeholder="$t('integrations.fiskaly_fr.siret_number_placeholder')"
        v-test="'fiskaly-siret-number'"
        :info="$t('integrations.fiskaly_fr.siret_number_info')"
      />
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import type { LocationProvisionAttributes } from '@/types';
import Address from './Address.vue';

const props = defineProps<{
  location: LocationProvisionAttributes;
  siretRegex: RegExp;
}>();

const sameAddress = ref(false);
const emit = defineEmits(['updateAddress']);

watch(sameAddress, (value) => {
  emit('updateAddress', value);
});
</script>
